<script>
export default {};
</script>

<template>
  <li
    class="list-none my-1 mx-0 border-b border-line-faint"
    :tabindex="null"
    :aria-disabled="true"
  />
</template>
